import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import './ModalTransferir.scss';
import { convertirIsoZComoLocal, formateoBasico } from '../../../utilities/formateos';
import { transferisServiciosIntegracion } from '../../../views/monitoreo/TransferirServicios/transferisServiciosIntegracion';
import Swal from 'sweetalert2';
import useGetDataUser from '../../../CustomHooks/useGetDataUser';

const ModalTransferir = ({ visible, onHide, data, actualizar, setActualizar,reloadBitacoras
}) => {
    const dataUser = useGetDataUser();
    const [fecha, setFecha] = useState(convertirIsoZComoLocal(data?.fecha) || null);
    const [operador, setOperador] = useState(null);
    const [motivo, setMotivo] = useState('');
    const [operadoresOptions, setOperadoresOptions] = useState();
    useEffect(() => {
        transferisServiciosIntegracion.getOperadores(setOperadoresOptions)
    }, []);


    const handleTransferir = async () => {
        if (!fecha || !operador || !motivo.trim()) {
            return;
        }
        if (data?.hora_banderazo) {
            Swal.fire({
                icon: 'warning',
                title: '⚠️ Servicio de transporte iniciado',
                text: `La bitácora seleccionada corresponde a un servicio que ya ha iniciado (Hora de banderazo: ${data.hora_banderazo}). ¿Desea continuar?`,
                showCancelButton: true,
                confirmButtonText: 'Continuar',
                cancelButtonText: 'Cerrar',
                focusConfirm: false,
                allowOutsideClick: false,
                allowEscapeKey: true,
                customClass: {
                    popup: 'swal2-transport-started'
                }
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await transferir();
                    await reloadBitacoras();
                }
            });
        }
        else {
            await transferir();
            await reloadBitacoras();
        }





    };
    const transferir = async () => {
        transferisServiciosIntegracion.transferirBitacora(data?.bitacora, formateoBasico(fecha), operador.code, motivo, dataUser.ID)
            .then((res) => {
                if (res.data.message != 'success') {
                    Swal.fire({
                        icon: 'error',   // Icono de error
                        title: res.data.message, // Título de la alerta
                    });
                }
                else {
                    Swal.fire({
                        icon: 'success',   // Icono de error
                        title: `Transferido correctamente`, // Título de la alerta
                    });
                    setFecha(null);
                    setOperador(null);
                    setMotivo('');
                    onHide();
                }
            })
            .catch((err) => {
                console.log("err", err);
            })


    }
    const handleCerrar = () => {
        setFecha(null);
        setOperador(null);
        setMotivo('');
        onHide();
    };

    const footer = (
        <>
            <Button
                label="Cerrar"
                icon="pi pi-times"
                onClick={handleCerrar}
                className="p-button-text"
            />
            <Button
                label="Transferir"
                icon="pi pi-check"
                onClick={handleTransferir}
                className="p-button-success"
                autoFocus
            />
        </>
    );

    return (
        <Dialog
            header="Transferir Bitácora"
            visible={visible}
            className="modal-transferir"
            footer={footer}
            onHide={handleCerrar}
            modal
        >
            <div className="modal-transferir-content">
                {data && (
                    <div className="info-section">
                        <p><strong>Bitácora:</strong> {data.bitacora}</p>
                        <p><strong>Ruta:</strong> {data.ruta}</p>
                        <p><strong>Operador:</strong> {data.nombre}</p>
                        <p><strong>Hora Arranque:</strong> {data.hora_arranque}</p>
                        <p><strong>Hora Llegada:</strong> {data.hora_llegada}</p>
                    </div>
                )}

                <div className="form-section">
                    <div className="p-fluid">
                        <div className="containerInputsFlex">
                            <div className="p-field">
                                <label htmlFor="operador">Operador *</label>
                                <Dropdown
                                    id="operador"
                                    value={operador}
                                    options={operadoresOptions}
                                    onChange={(e) => setOperador(e.value)}
                                    placeholder="Seleccione un operador"
                                    optionLabel="name"
                                />
                            </div>
                        </div>

                        <div className="p-field">
                            <label htmlFor="motivo">Motivo *</label>
                            <InputTextarea
                                id="motivo"
                                value={motivo}
                                onChange={(e) => setMotivo(e.target.value)}
                                rows={5}
                                placeholder="Ingrese el motivo de la transferencia"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default ModalTransferir;
